// Subtle topographic contour backdrop — evokes maps of Country.
export default function TopoBackground({ className = "", opacity = 0.06 }) {
  return (
    <svg
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 h-full w-full ${className}`}
      viewBox="0 0 1200 600"
      preserveAspectRatio="xMidYMid slice"
      style={{ opacity }}
    >
      <g fill="none" stroke="#D4A373" strokeWidth="1">
        {Array.from({ length: 9 }).map((_, i) => {
          const o = i * 26;
          return (
            <path
              key={i}
              d={`M -50 ${180 + o}
                 C 200 ${120 + o}, 380 ${260 + o}, 600 ${210 + o}
                 S 1000 ${120 + o}, 1260 ${200 + o}`}
            />
          );
        })}
        {Array.from({ length: 6 }).map((_, i) => {
          const o = i * 22;
          return (
            <ellipse
              key={`e${i}`}
              cx="880"
              cy="360"
              rx={90 + o * 2.4}
              ry={54 + o * 1.4}
            />
          );
        })}
      </g>
    </svg>
  );
}
